import styles from "./herosection.module.css";
import { Phone } from "lucide-react";
import heroImg from "../../assets/backgrounds/hero.png";
const HeroSection = () => {
  return (
    <section className={styles.heroSection_wrapper}>
      <div className={styles.heroSection_inner}>
        {/* Left Content */}
        <div className={styles.heroSection_left}>
          <h1 className={styles.heroSection_heading}>
            Welcome to{" "}
            <span className={styles.heroSection_gradientText}>
              Osmossion Dialysis
            </span>
          </h1>

          <p className={styles.heroSection_paragraph}>
            At Osmossion Dialysis Centre, we are dedicated to delivering safe,
            comfortable, and effective dialysis treatments in a supportive
            environment. Our expert medical team combines advanced equipment
            with a patient-first approach, ensuring your health, dignity, and
            comfort are always our top priorities.
          </p>

          <a href="tel:+916901740874">
            <button className={styles.heroSection_button}>
              <Phone className={styles.arrowIcon} /> Call us for Enquiry
            </button>
          </a>

        </div>

        {/* Right Image */}
        <div className={styles.heroSection_right}>
          <img
            src={heroImg}
            alt="Dialysis Patient"
            className={styles.heroSection_image}
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
